export default __webpack_public_path__ + "img/person.d0b82e4.svg";